import { baseApi } from "@/shared/api/baseApi";
import {
  capabilityReadinessProbeResponseSchema,
  capabilityReadinessResponseSchema,
} from "./capabilityReadinessSchemas";

export interface CapabilityReadinessQuery {
  organizationId: string;
  shopBindingId?: string;
}

export interface CapabilityReadinessProbeQuery extends CapabilityReadinessQuery {
  expectedScopeVersion?: string;
  mode?: "auto" | "manual";
}

export function capabilityReadinessRequest(input: CapabilityReadinessQuery) {
  return {
    params: input.shopBindingId
      ? { shop_binding_id: input.shopBindingId }
      : {},
    url: `/v1/organizations/${encodeURIComponent(input.organizationId)}/capability-readiness`,
  };
}

export function capabilityReadinessProbeRequest(input: CapabilityReadinessProbeQuery) {
  const mode = input.mode ?? "manual";
  return {
    body:
      mode === "auto"
        ? {
            expected_scope_version: input.expectedScopeVersion ?? "",
            mode,
          }
        : { mode },
    method: "POST" as const,
    params: { shop_binding_id: input.shopBindingId ?? "" },
    url: `/v1/organizations/${encodeURIComponent(input.organizationId)}/capability-readiness/probe`,
  };
}

export const capabilityReadinessApi = baseApi
  .enhanceEndpoints({ addTagTypes: ["CapabilityReadiness"] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCapabilityReadiness: builder.query<
        ReturnType<typeof capabilityReadinessResponseSchema.parse>,
        CapabilityReadinessQuery
      >({
        query: capabilityReadinessRequest,
        transformResponse: (response) =>
          capabilityReadinessResponseSchema.parse(response),
        providesTags: (_result, _error, input) => [
          {
            id: `${input.organizationId}:${input.shopBindingId ?? ""}`,
            type: "CapabilityReadiness",
          },
        ],
      }),
      probeCapabilityReadiness: builder.mutation<
        ReturnType<typeof capabilityReadinessProbeResponseSchema.parse>,
        CapabilityReadinessProbeQuery
      >({
        query: capabilityReadinessProbeRequest,
        transformResponse: (response) =>
          capabilityReadinessProbeResponseSchema.parse(response),
      }),
    }),
  });

export const {
  useGetCapabilityReadinessQuery,
  useProbeCapabilityReadinessMutation,
} = capabilityReadinessApi;
